import React from "react";
import "./Process.css";

const Process = () => {
    return (
        <div className="process-container">
            <h2 className="process-header">Our Process</h2>
            <div className="process">
                <div className="process-step">
                    <div className="step-number">1</div>
                    <div className="step-content">
                        <h2>Understanding Your Vision</h2>
                        <p>
                            Our journey begins with understanding your unique
                            vision for your backyard. Whether you envision a
                            cozy fireplace, a serene spa, or an outdoor kitchen,
                            we listen closely to your ideas and requirements. We
                            thrive on innovation and creativity, collaborating
                            with you to brainstorm and craft a truly
                            one-of-a-kind design.
                        </p>
                    </div>
                </div>

                <div className="process-step">
                    <div className="step-number">2</div>
                    <div className="step-content">
                        <h2>Developing a Prototype</h2>
                        <p>
                            With a clear vision in hand, we move to the next
                            phase: developing a 3D rendering of your dream
                            backyard. This prototype serves as a rough draft,
                            allowing for any new ideas and adjustments you may
                            have. It’s an exciting step where your concepts
                            start to come to life.
                        </p>
                    </div>
                </div>

                <div className="process-step">
                    <div className="step-number">3</div>
                    <div className="step-content">
                        <h2>Bringing the Design to Life</h2>
                        <p>
                            Congratulations! Your final 3D design is complete,
                            showcasing the paradise you’ve envisioned. Now, we
                            transition from design to reality, connecting you
                            with trusted vendors to bring your 3D rendering to
                            life. Your dream backyard is just around the corner.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Process;
